<template>
  <div class="full-width">
    <div class="d-flex justify-space-between align-center mx-2 mb-4">
      <v-btn text color="primary" @click="close"><v-icon>mdi-chevron-left</v-icon>Back</v-btn>
      <v-text-field
        outlined
        placeholder="Search"
        prepend-icon="mdi-magnify"
        clearable
        single-line
        dense
        hide-details
        v-model="search"
        class="shrink"
      ></v-text-field>
    </div>
    <v-data-table
      :headers="budgetColumns"
      :items="budgetActivity"
      :search="search"
      item-key="budgetActivityId"
      :items-per-page="10"
      class="elevation-0 full-width budget-table"
      loading-text="Loading... Please wait"
      no-data-text="No funding activity found"
    >
      <template v-slot:[`item.amount`]="{ item }">
        <span>{{ formatCurrency(item.amount, item.Award || { awardId: item.awardId }) }}</span>
      </template>
      <template v-slot:[`item.description`]="{ item }">
        <span>{{ item.description }}</span>
      </template>
      <template v-slot:[`item.formattedStatus`]="{ item }">
        <div class="d-flex align-center">
          <v-icon v-if="item.formattedStatus == 'Complete'" class="mr-2" color="success"
            >mdi-check-circle-outline</v-icon
          >
          <v-icon v-else-if="item.formattedStatus == 'Pending'" class="mr-2" color="orange"
            >mdi-clock-outline</v-icon
          >
          <v-icon v-else-if="item.formattedStatus == 'Request Pending'" class="mr-2" color="orange"
            >mdi-account-clock</v-icon
          >

          <span>{{ item.formattedStatus }}</span>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
// import Robin from "@/components/Robin";

import moment from "moment";
import { mapState } from "vuex";
import formatCurrencyMixin from "@/mixins/formatCurrency";

export default {
  name: "BudgetActivityManager",
  mixins: [formatCurrencyMixin],
  props: { budgets: Array, clientId: Number, budgetId: Number },
  components: {
    // Robin,
  },
  data() {
    return {
      currentSlide: 0,
      slideDirection: "topic-left",
      search: null,
      budgetColumns: [
        { text: "Date", value: "createdAtFormatted", width: "12%" },
        { text: "Budget", value: "budgetName", width: "16%" },
        { text: "Type", value: "type", width: "12%" },
        { text: "User", value: "User.displayName", width: "16%" },
        { text: "Description", value: "description", width: "18%" },
        { text: "Amount", value: "amount", width: "12%" },
        {
          text: "Status",
          value: "formattedStatus",
          width: "14%",
          align: "center",
        },
      ],
    };
  },
  created() {},
  beforeUnmount() {},
  methods: {
    close() {
      this.$emit("close");
    },
  },
  computed: {
    ...mapState(["userProfile", "displayWalletMenu", "walletMenuScreen"]),
    budgetActivity() {
      if (!this.budgets) {
        return [];
      }
      var budgetActivity = [];
      this.budgets
        .filter(
          (x) => x.clientId == this.clientId && (!this.budgetId || x.budgetId == this.budgetId)
        )
        .forEach((budget) => {
          (budget.BudgetActivities || []).forEach((activity) => {
            activity.awardId = activity.awardId || budget.awardId;
            activity.Award = activity.Award || budget.Award;
            budgetActivity.push(activity);
          });
        });

      return budgetActivity
        .sort((a, b) => (moment(a.createdAt).isBefore(b.createdAt) ? 1 : -1))
        .filter((activity) => activity.displayInFundingActivity)
        .map((activity) => {
          if (
            (!activity.stripeStatus &&
              (activity.type == "MANUAL" ||
                activity.type == "FUNDS_REMOVED" ||
                activity.type == "BUDGET_TO_BUDGET")) ||
            activity.stripeStatus == "succeeded"
          ) {
            activity.formattedStripeStatus = "Complete";
          } else if (activity.stripeStatus == "pending") {
            activity.formattedStripeStatus = "Pending";
          } else if (activity.status == "Requested")
            activity.formattedStripeStatus = "Request Pending";
          else if (activity.status == "Declined")
            activity.formattedStripeStatus = "Request Declined";
          else activity.formattedStripeStatus = activity.stripeStatus;

          // Status column reads formattedStatus; budget-service only sets that for
          // MANUAL / BUDGET_TO_BUDGET today.
          activity.formattedStatus = activity.formattedStripeStatus || activity.formattedStatus;

          if (activity.type == "CREDIT_CARD") {
            activity.type = "CC";
          } else if (activity.type == "ACH") {
            activity.type = "ACH";
          } else if (activity.type == "MANUAL") {
            activity.type = "Manual";
          } else if (activity.type == "BUDGET_TO_BUDGET") {
            activity.type = "Budget Transfer";
          } else if (activity.type == "FUNDS_REMOVED") {
            activity.type = "Funds Removed";
          }

          activity.createdAtFormatted = moment(activity.createdAt)
            .utc()
            .local()
            .format("MMM DD, YYYY");
          return activity;
        });
    },
  },
  watch: {},
};
</script>

<style scoped>
.budget-table {
  border: solid 1px;
  border-color: lightgray;
  border-radius: 0;
}

.budget-table >>> .v-data-table-header {
  background-color: white;
}
</style>
